import { PrizeType } from 'entities/prize/model';
import { prizesApi } from './prizesApi';

type PrizeTypeParams = {
  size?: number;
  page?: number;
};

type PrizeTypeIdParams = {
  id: string | undefined;
};

type GetPrizeListType = {
  items: PrizeType[];
  page: number;
  pages: number;
  size: number;
  total: number;
};

const getPrizeListApi = prizesApi.injectEndpoints({
  endpoints: (builder) => ({
    getPrizeList: builder.query<GetPrizeListType, PrizeTypeParams>({
      query: ({ size, page }) => {
        const sizeParams = size ? `&size=${size}` : '';
        const pageParams = page ? `page=${page}` : '';
        return {
          url: `shop/admin/v1/prize-type/prize-types?${pageParams}${sizeParams}`,
          method: 'GET',
        };
      },
      providesTags: ['Prizes'],
    }),
    getPrizeId: builder.query<PrizeType, PrizeTypeIdParams>({
      query: ({ id }) => ({
        url: `shop/admin/v1/prize-type/prize-types/${id}`,
      }),
      providesTags: ['PrizeId'],
    }),
  }),
});

export const { useGetPrizeListQuery, useGetPrizeIdQuery } = getPrizeListApi;
